<template>
    <div>
        <ul
                class="toggle-switch"
                :class="{'square' : defaultOptions.layout.squareCorners}"
                :style="toggleSwitchStyle"
        >
            <li
                    :style="itemStyle"
                    v-for="(label, index) in defaultOptions.items.labels"
                    :key="index"
            >
                <input
                        :disabled="defaultOptions.items.disabled || disabled"
                        :id="label.Name + group" :value="label.Name"
                        type="radio"
                        v-on:click="toggle"
                >
                <label
                        v-if="label.Name === defaultOptions.items.preSelected"
                        :style="labelStyleSelected('#131313', '#ffffff')"
                        :class="{ active: !defaultOptions.items.disabled || disabled, disabled: defaultOptions.items.disabled}"
                        class="selected selectButton"
                        :for="label.Name + group"
                        type="radio"
                        :id="group+' - '+label.Name"
                >
                    {{ label.Description }}
                </label>
                <label
                        v-else
                        :style="labelStyle"
                        :class="{active: !defaultOptions.items.disabled || disabled, disabled: defaultOptions.items.disabled}"
                        class="selectButton"
                        :for="label.Name + group"
                        type="radio"
                        :id="group+' - '+label.Name"
                >
                    {{ label.Description }}
                </label>
                <i v-if="label.InfoText" class="fas fa-info-circle info-icon" data-toggle="modal" data-target="#selectModal" :data-title="'Ausstattungsdetails für ' + label.Description" :data-message="label.InfoText" ></i>
            </li>
        </ul>
    </div>
</template>

<script>
    const s = x => x + 's'
    const rem = v => v + 'rem'

    export default {
        name: 'ToggleSwitch',
        props: {
            options: {
                type: Object,
                required: false
            },
            value: {
                type: String,
                required: false
            },
            Name: {
                type: String,
                required: false
            },
            group: {
                type: String,
                required: false,
                default: ''
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            loading: Boolean
        },
        created() {
            this.defaultOptions = {
                layout: {
                    color: 'black',
                    backgroundColor: 'white',
                    selectedColor: 'white',
                    selectedBackgroundColor: 'green',
                    borderColor: '#afb0af',
                    fontFamily: 'Arial',
                    fontWeight: 'normal',
                    fontWeightSelected: 'bold',
                    squareCorners: true,
                    noBorder: false
                },
                size: {
                    fontSize: 1,
                    height: 5.625,
                    padding: 2.0,
                    width: 23.75
                },
                items: {
                    delay: .4,
                    preSelected: 'unknown',
                    disabled: false,
                    labels: [ ]
                }
            }
        },
        mounted() {
            let parent = this;

            if (this.options !== null && this.options !== undefined) {
                this.mergeDefaultOptionsWithProp(this.options)
            }

            if (parent.defaultOptions.items.preSelected !== 'unknown') {
                parent.selectedItem = parent.defaultOptions.items.preSelected
                parent.$emit('input', this.selectedItem)
            } else if (this.value) {
                this.selectedItem = this.value;
                this.$emit('input', this.selectedItem)
            }
        },
        data() {
            return {
                selected: false,
                selectedItem: 'unknown',
                defaultOptions: Object
            }
        },
        computed: {
            toggleSwitchStyle() {
                return {
                    width: rem(this.defaultOptions.size.width),
                    height: rem(this.defaultOptions.size.height)
                }
            },
            itemStyle() {
                return {
                    width: rem(this.defaultOptions.size.width),
                    height: rem(this.defaultOptions.size.height),
                    fontFamily: this.defaultOptions.layout.fontFamily,
                    fontSize: rem(this.defaultOptions.size.fontSize),
                    textAlign: 'center'
                }
            },
            labelStyle() {
                return {
                    padding: rem(this.defaultOptions.size.padding),
                    borderColor: this.defaultOptions.layout.noBorder ? 'transparent' : this.defaultOptions.layout.borderColor,
                    backgroundColor: this.defaultOptions.layout.backgroundColor,
                    color: this.defaultOptions.layout.color,
                    fontWeight: this.defaultOptions.layout.fontWeight,
                    transition: s(this.defaultOptions.items.delay)
                }
            }
        },
        methods: {
            toggle(event) {
                if (!this.defaultOptions.items.disabled) {
                    this.selected = true
                    this.selectedItem = event.target.id.replace(this.group, '')
                    this.defaultOptions.items.preSelected = event.target.id.replace(this.group, '');
                    this.$emit('selected', this.selected)
                    this.$emit('input', this.selectedItem)
                    this.$emit('change', {
                        value: event.target.id.replace(this.group, ''),
                        srcEvent: event
                    })
                }
            },
            labelStyleSelected(color, backgroundColor) {
                return {
                    padding: rem(this.defaultOptions.size.padding),
                    borderColor: this.defaultOptions.layout.noBorder ? 'transparent' : this.defaultOptions.layout.borderColor,
                    fontWeight: this.defaultOptions.layout.fontWeightSelected,
                    backgroundColor: backgroundColor !== undefined ? backgroundColor : this.defaultOptions.layout.selectedBackgroundColor,
                    color: color !== undefined ? color : this.defaultOptions.layout.selectedColor,
                    transition: s(this.defaultOptions.items.delay)
                }
            },
            mergeDefaultOptionsWithProp(options) {
                var result = this.defaultOptions
                for (var option in options)
                {
                    if (options[option] !== null && typeof(options[option]) === 'object') {
                        for (var subOption in options[option]) {
                            if (options[option][subOption] !== undefined && options[option][subOption] !== null) {
                                result[option][subOption] = options[option][subOption]
                            }
                        }
                    } else {
                        result[option] = options[option]
                    }
                }
            }
        },
        watch: {
            value(val) {
                this.selectedItem = val
            },
            options(val) {
                if (val !== null && val !== undefined) {
                    this.mergeDefaultOptionsWithProp(val)
                }
            }
        }
    }
</script>

<style scoped>
    ul {
        list-style: none;
    }

    label {
        margin: 0;
    }

    .toggle-switch {
        padding: 0;
        margin: 0;
        display: inline-flex;
    }

    .square li:first-child label {
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
    }
    .square li:last-child label {
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }

    .toggle-switch li {
        position:relative;
        margin-bottom: 1% !important;
    }

    .toggle-switch li:first-child label {
        border: 1px solid;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .toggle-switch li:last-child label {
        border-right: 1px solid;
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .toggle-switch label, .toggle-switch input {
        display:block;
        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
    }

    .toggle-switch input[type="radio"] {
        opacity:0.01;
        z-index:100;
    }

    .toggle-switch .info-icon {
        z-index: 101;
        cursor: pointer;
        position: absolute;
        left:  50px;
        top: 30px;
        font-size: 24px;
        color: #394451;
        transition:font-size 0.2s;
        -moz-transition:font-size 0.2s; /* Firefox 4 */
        -webkit-transition:font-size 0.2s; /* Safari and Chrome */
    }
    .toggle-switch .info-icon:hover {
        color: #ec7205;
    }

    .active {
        cursor: pointer;
    }

</style>
